// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1UM5j","title":"AfterFrontImage_title__3vsoV"};